import { useMemo, useState, Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FLINT, LORAX } from 'HubStyleTokens/colors';
import H2 from 'UIComponents/elements/headings/H2';
import HR from 'UIComponents/elements/HR';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIModal from 'UIComponents/dialog/UIModal';
import UILink from 'UIComponents/link/UILink';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIImage from 'UIComponents/image/UIImage';
import ScopesAuthorization from 'developer-experience-shared-components/scopes/components/scopesAuthorization/ScopesAuthorization';
import * as ScopeGroupType from '../../../common/constants/scopes/ScopeGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RequiredPermissions = ({
  appName,
  connectionType,
  homemade,
  iconUrl,
  neededScopeGroups,
  trackInteraction
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const filteredScopeGroups = useMemo(() => {
    return neededScopeGroups && neededScopeGroups.filter(scope => {
      return scope.name !== ScopeGroupType.OAUTH;
    });
  }, [neededScopeGroups]);
  const descriptionText = useMemo(() => {
    if (homemade && connectionType !== 'STANDARD') {
      return /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.subheadingText.homemadeAppTooltip"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.subheadingText.homemadeAppPermissions"
        })
      });
    } else if (!filteredScopeGroups.length) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.subheadingText.noRequiredPermissions",
        options: {
          appName
        }
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.subheadingText.viewPermissions_jsx",
        elements: {
          Link: UILink
        },
        options: {
          onClick: () => {
            setModalOpen(true);
            trackInteraction('click required account permissions');
          }
        }
      });
    }
  }, [appName, homemade, connectionType, filteredScopeGroups, trackInteraction]);
  const modal = useMemo(() => /*#__PURE__*/_jsxs(UIModal, {
    width: 500,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.modal.header"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => setModalOpen(false)
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "p-bottom-12",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "center",
        className: "p-y-4",
        children: [/*#__PURE__*/_jsx(UIImage, {
          alt: appName,
          src: iconUrl,
          style: {
            maxHeight: 60
          }
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "add",
          color: FLINT,
          size: "xs",
          className: "p-x-4"
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "sprocket",
          color: LORAX,
          size: "sm"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "text-center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.permissions.modal.subtitle",
          options: {
            appName
          }
        })
      }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(ScopesAuthorization, {
        requestedScopes: filteredScopeGroups
      })]
    })]
  }), [appName, iconUrl, filteredScopeGroups]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [descriptionText, modalOpen && modal]
  });
};